import { ONE_MAP, SELECT_SYNC_MAPS_CONFIGURATION, DOCUMENTS, SELECT_MAP_REQUEST_VIEWER_TAB, SELECT_NO_MORE_MAP_REQUEST_TO_FETCH, SELECT_MAP_REQUEST_REFRESH_LENGTH } from "../constants/mapRequest";
import { MAP_REQUEST_PER_PAGE } from "../../screen/container/EasyScaleMap"

const initialState = {
    syncMapsConfiguration: ONE_MAP,
    tab: DOCUMENTS,
    noMoreMapRequestToFetch: false,
    mapRequestRefreshLength: MAP_REQUEST_PER_PAGE
};
export default (state = initialState, action) => {
    switch (action.type) {
        case SELECT_SYNC_MAPS_CONFIGURATION:
            return {
                ...state,
                syncMapsConfiguration: action.payload
            }

        case SELECT_MAP_REQUEST_VIEWER_TAB:
            return {
                ...state,
                tab: action.payload
            }
        case SELECT_NO_MORE_MAP_REQUEST_TO_FETCH:
            return {
                ...state,
                noMoreMapRequestToFetch: action.payload
            }
        case SELECT_MAP_REQUEST_REFRESH_LENGTH: 
            return {
                ...state,
                mapRequestRefreshLength: action.payload
            }
        default:
            return state;
    }
};
